import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Carlos Mendoza',
  role: 'Director Comercial, TechFlow Solutions',
  content: 'Desde que implementamos el sistema de Nicova Digital, nuestro equipo de ventas no pierde tiempo en leads fríos. La IA califica y el CRM nos organiza todo. Aumentamos las ventas un 40% en 3 meses.'
}, {
  name: 'Laura Gutiérrez',
  role: 'CEO, Innova Salud',
  content: 'Habíamos probado con varias agencias de marketing sin ver un retorno real. Nicova cambió el juego con su enfoque en automatización y datos. Ahora sabemos exactamente cuánto nos cuesta cada paciente nuevo.'
}, {
  name: 'Andrés Silva',
  role: 'Fundador, Logística Avanzada',
  content: 'El dashboard de resultados es increíble. Ver cómo las campañas de Google Ads se conectan directamente con nuestro proceso de ventas nos ha dado una claridad que nunca habíamos tenido.'
}];
export function Testimonials() {
  return <section id="testimonios" className="py-24 bg-brand-cyan/5" data-id="element-231">
      <div className="container mx-auto px-6 md:px-12" data-id="element-232">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-233">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-234">
            Lo que dicen nuestros clientes
          </motion.h2>
          <p className="text-lg text-slate-600" data-id="element-235">
            Empresas B2B que ya están escalando con nuestros sistemas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-236">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-card transition-shadow duration-300 flex flex-col" data-id="element-237">
              <div className="flex gap-1 mb-6" data-id="element-238">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} size={18} className="fill-brand-cyan text-brand-cyan" data-id="element-239" />)}
              </div>

              <p className="text-slate-600 mb-8 flex-1 italic" data-id="element-240">
                "{testimonial.content}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-241">
                <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center font-bold text-slate-400 text-xl" data-id="element-242">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-243">
                  <div className="font-bold text-brand-black" data-id="element-244">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-slate-500" data-id="element-245">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}